import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "HOME" },
    { path: "/about", label: "THE ATELIER" },
    { path: "/collections", label: "COLLECTIONS" },
    { path: "/craftsmanship", label: "CRAFTSMANSHIP" },
    { path: "/contact", label: "APPOINTMENTS" },
    { path: "/contact", label: "CONTACT" }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#FAF9F7]/95">
      <div className="max-w-7xl mx-auto px-12 py-9">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex-shrink-0 ml-2">
            <Link to="/" className="block">
              <div style={{ fontFamily: "'Playfair Display', serif" }}>
                <div 
                  className="text-[22px] tracking-[0.02em] leading-none"
                  style={{ 
                    color: '#6B3E1F',
                    fontWeight: 400,
                    letterSpacing: '0.02em'
                  }}
                >
                  MIA
                </div>
                <div 
                  className="text-[9px] tracking-[0.25em] uppercase mt-0.5"
                  style={{ 
                    color: '#6B3E1F',
                    fontWeight: 300,
                    letterSpacing: '0.25em'
                  }}
                >
                  Atelier
                </div>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation - Right Aligned */}
          <nav className="hidden md:flex items-center space-x-12">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-[10px] tracking-[0.2em] uppercase transition-colors duration-700 font-light ${
                  isActive(link.path)
                    ? "text-[#2C2C2C]"
                    : "text-[#8B7D6B] hover:text-[#2C2C2C]"
                }`}
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-[#8B7D6B] hover:text-[#2C2C2C] transition-colors duration-500"
          >
            {mobileMenuOpen ? <X size={18} strokeWidth={1} /> : <Menu size={18} strokeWidth={1} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-8 pb-6 flex flex-col space-y-5">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`text-[10px] tracking-[0.2em] uppercase transition-colors duration-700 font-light ${
                  isActive(link.path)
                    ? "text-[#2C2C2C]"
                    : "text-[#8B7D6B] hover:text-[#2C2C2C]"
                }`}
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};
